import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConsts } from "@shared/app-consts";
import { BaseService } from "@services/base.service";
import { ApplicationConnectRequest, ApplicationConnectResponse, ApplicationConnectStatus, ApplicationConnectorModel, ListApplicationConnectRequest } from "@shared/models/application-connect";
import { PagedList } from "@shared/list/paged-list";

@Injectable({
  providedIn: "root",
})
export class ApplicationConnectService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  connect(request: ApplicationConnectRequest): Observable<ApplicationConnectResponse> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.post(
      AppConsts.API_SERVICE_URL + `ApplicationConnector/connect`,
      request,
      httpOptions
    ) as Observable<ApplicationConnectResponse>;
  }

  list(request: ListApplicationConnectRequest): Observable<PagedList<ApplicationConnectorModel>> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.get(
      AppConsts.API_SERVICE_URL + "ApplicationConnector",
      httpOptions
    ) as Observable<PagedList<ApplicationConnectorModel>>;
  }

  getStatusLabel(status: ApplicationConnectStatus): string {
    switch (status) {
      case ApplicationConnectStatus.Connected:
        return "Connecté";
      case ApplicationConnectStatus.NotConnected:
        return "Déconnecté";
      default:
        return "";
    }
  }

  getStatusColor(status: ApplicationConnectStatus): string {
    switch (status) {
      case ApplicationConnectStatus.Connected:
        return "#1cc88a";
      case ApplicationConnectStatus.NotConnected:
        return "rgb(3, 194, 252)";
    }
  }
}
